<template>
  <router-view />
</template>

<style>
/* 웹폰트 > 미사용 */
/* @import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR&family=Nanum+Gothic&family=Nanum+Myeongjo&family=Nanum+Pen+Script&display=swap'); */
/* @import url("https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/static/pretendard.min.css"); */
</style>
